﻿import Vue from 'vue'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueRouter from 'vue-router'
import VueDraggable from 'vuedraggable'
import DeviceHubPlugin from './plugins/deviceHubPlugin'
import ChatHubPlugin from './plugins/chatHubPlugin'
import MasonryWall from '@yeger/vue2-masonry-wall'
import HeartBeatWorker from './heartBeatWorker.js?worker'
import MarqueeText from 'vue-marquee-text-component'
import { loadCodeMirror } from './services/codeMirrorLoader'
import { assetUrl } from './assetUrl'

// Import service worker registration script
import './register-sw.js'

// Makes all Vuetify dialogs movable by dragging their header.
import './draggableDialogs.js'

const worker = new HeartBeatWorker();
worker.postMessage('ping');


Vue.component('AccountAccessEditor', () => import('./components/accounts/accountAccessEditor.vue'));
Vue.component('AccountDialog', () => import('./components/accounts/accountDialog.vue'));
Vue.component('ChangePasswordDialog', () => import('./components/accounts/changePasswordDialog.vue'));
Vue.component('SingleAccessEditor', () => import('./components/accounts/singleAccessEditor.vue'));
Vue.component('UserDialog', () => import('./components/accounts/userDialog.vue'));

Vue.component('Assets', () => import('./components/assets/assets.vue'));
Vue.component('AssetBrowser', () => import('./components/assets/assetBrowser.vue'));
Vue.component('MoveToFolderDialog', () => import('./components/assets/moveToFolderDialog.vue'));
Vue.component('Fonts', () => import('./components/fonts/fonts.vue'));
Vue.component('GoogleFontPickerDialog', () => import('./components/fonts/googleFontPickerDialog.vue'));
Vue.component('AssetUploader', () => import('./components/assets/assetUploader.vue'));
Vue.component('FileBrowseButton', () => import('./components/assets/fileBrowseButton.vue'));
Vue.component('FileDropZone', () => import('./components/assets/fileDropZone.vue'));
Vue.component('UploadQueue', () => import('./components/assets/uploadQueue.vue'));

Vue.component('AlertDialog', () => import('./components/common/alertDialog.vue'));
Vue.component('CollapseCard', () => import('./components/common/collapseCard.vue'));
Vue.component('ConfirmDialog', () => import('./components/common/confirmDialog.vue'));
Vue.component('UpgradePlanDialog', () => import('./components/common/upgradePlanDialog.vue'));
Vue.component('SubscriptionRequiredDialog', () => import('./components/subscriptions/subscriptionRequiredDialog.vue'));
Vue.component('ChangePlanDialog', () => import('./components/subscriptions/changePlanDialog.vue'));
Vue.component('DismissibleAlert', () => import('./components/common/dismissibleAlert.vue'));
Vue.component('Error', () => import('./components/common/error.vue'));
Vue.component('InputDialog', () => import('./components/common/inputDialog.vue'));
Vue.component('LoadingIndicator', () => import('./components/common/loadingIndicator.vue'));
Vue.component('PublishButton', () => import('./components/common/publishButton.vue'));
Vue.component('StandardDialog', () => import('./components/common/standardDialog.vue'));
Vue.component('GoogleMaps', () => import('./components/common/googleMaps.vue'));

Vue.component('AddEditDeviceDialog', () => import('./components/devices/addEditDeviceDialog.vue'));
Vue.component('AddLitePlayerDialog', () => import('./components/devices/addLitePlayerDialog.vue'));
Vue.component('Device', () => import('./components/devices/device.vue'));
Vue.component('DeviceHeartbeat', () => import('./components/devices/deviceHeartbeat.vue'));
Vue.component('DeviceInfo', () => import('./components/devices/deviceInfo.vue'));
Vue.component('DeviceNotFound', () => import('./components/devices/deviceNotFound.vue'));
Vue.component('DeviceRemoteManagementDialog', () => import('./components/devices/deviceRemoteManagementDialog.vue'));
Vue.component('DeviceResolver', () => import('./components/devices/deviceResolver.vue'));
Vue.component('DeviceSelector', () => import('./components/devices/deviceSelector.vue'));
Vue.component('DeviceUpdateStatus', () => import('./components/devices/deviceUpdateStatus.vue'));
Vue.component('DeviceVersion', () => import('./components/devices/deviceVersion.vue'));
Vue.component('HeartBeatCountdown', () => import('./components/devices/HeartBeatCountdown.vue'));
Vue.component('LinkDeviceDialog', () => import('./components/devices/linkDeviceDialog.vue'));

Vue.component('Players', () => import('./components/players/players.vue'));
Vue.component('PlayerInfo', () => import('./components/players/playerInfo.vue'));
Vue.component('AddEditPlayerDialog', () => import('./components/players/addEditPlayerDialog.vue'));
Vue.component('AddEditMonitorDialog', () => import('./components/players/addEditMonitorDialog.vue'));
Vue.component('VideoWallDialog', () => import('./components/players/videoWallDialog.vue'));
Vue.component('AdoptPlayerDialog', () => import('./components/players/adoptPlayerDialog.vue'));
Vue.component('LinkPlayerDialog', () => import('./components/players/linkPlayerDialog.vue'));
Vue.component('PlayerRemoteManagementDialog', () => import('./components/players/playerRemoteManagementDialog.vue'));
Vue.component('PreLoader', () => import('./components/devices/preLoader.vue'));
Vue.component('SelectDeviceDialog', () => import('./components/devices/selectDeviceDialog.vue'));

Vue.component('Grid', () => import('./components/gridTable/grid.js'));
Vue.component('GridTable', () => import('./components/gridTable/gridTable.vue'));

Vue.component('Dashboard', () => import('./components/dashboard/dashboard.vue'));

Vue.component('AccountSelector', () => import('./components/layout/accountSelector.vue'));
Vue.component('Administration', () => import('./components/layout/administration.vue'));
Vue.component('CurrentUser', () => import('./components/layout/currentUser.vue'));
Vue.component('Notifications', () => import('./components/layout/notifications.vue'));
Vue.component('Navigation', () => import('./components/layout/navigation.vue'));

Vue.component('QrCodeEditor', () => import('./components/propertyEditors/qrCodeEditor.vue'));
Vue.component('QrCodeEditorWebsite', () => import('./components/propertyEditors/qr/qrCodeEditorWebsite.vue'));
Vue.component('QrCodeEditorText', () => import('./components/propertyEditors/qr/qrCodeEditorText.vue'));
Vue.component('QrCodeEditorWifi', () => import('./components/propertyEditors/qr/qrCodeEditorWifi.vue'));
Vue.component('QrCodeEditorEmail', () => import('./components/propertyEditors/qr/qrCodeEditorEmail.vue'));
Vue.component('QrCodeEditorPhoneNumber', () => import('./components/propertyEditors/qr/qrCodeEditorPhoneNumber.vue'));
Vue.component('QrCodeEditorSms', () => import('./components/propertyEditors/qr/qrCodeEditorSms.vue'));
Vue.component('QrCodeEditorNumber', () => import('./components/propertyEditors/qr/qrCodeEditorNumber.vue'));
Vue.component('QrCodeEditorGeoLocation', () => import('./components/propertyEditors/qr/qrCodeEditorGeoLocation.vue'));
Vue.component('QrCodeEditorPlayStore', () => import('./components/propertyEditors/qr/qrCodeEditorPlayStore.vue'));
Vue.component('QrCodeEditorAppStore', () => import('./components/propertyEditors/qr/qrCodeEditorAppStore.vue'));
Vue.component('QrCodeEditorVcard', () => import('./components/propertyEditors/qr/qrCodeEditorVcard.vue'));
Vue.component('QrCodeEditorVcalendar', () => import('./components/propertyEditors/qr/qrCodeEditorVcalendar.vue'));

Vue.component('AnimationEditor', () => import('./components/propertyEditors/animationEditor.vue'));
Vue.component('AssetEditor', () => import('./components/propertyEditors/assetEditor.vue'));
Vue.component('MultiAssetEditor', () => import('./components/propertyEditors/multiAssetEditor.vue'));
Vue.component('BackgroundRepeatEditor', () => import('./components/propertyEditors/backgroundRepeatEditor.vue'));
Vue.component('BackgroundSizeEditor', () => import('./components/propertyEditors/backgroundSizeEditor.vue'));
Vue.component('BooleanEditor', () => import('./components/propertyEditors/booleanEditor.vue'));
Vue.component('BorderEditor', () => import('./components/propertyEditors/borderEditor.vue'));
Vue.component('BorderBackgroundEditor', () => import('./components/propertyEditors/borderBackgroundEditor.vue'));
Vue.component('FontEditor', () => import('./components/propertyEditors/fontEditor.vue'));
Vue.component('ClassEditor', () => import('./components/propertyEditors/classEditor.vue'));
Vue.component('ColorEditor', () => import('./components/propertyEditors/colorEditor.vue'));
Vue.component('DeviceGroupSelectionEditor', () => import('./components/propertyEditors/deviceGroupSelectionEditor.vue'));
Vue.component('DropShadowEditor', () => import('./components/propertyEditors/dropShadowEditor.vue'));
Vue.component('MultiSelectEditor', () => import('./components/propertyEditors/multiSelectEditor.vue'));
Vue.component('NumberEditor', () => import('./components/propertyEditors/numberEditor.vue'));
Vue.component('RangeEditor', () => import('./components/propertyEditors/rangeEditor.vue'));
Vue.component('ScreenSelectionEditor', () => import('./components/propertyEditors/screenSelectionEditor.vue'));
Vue.component('PlaylistSelectionEditor', () => import('./components/propertyEditors/playlistSelectionEditor.vue'));
Vue.component('SelectEditor', () => import('./components/propertyEditors/selectEditor.vue'));
Vue.component('AssetStorageProviderEditor', () => import('./components/settings/assetStorageProviderEditor.vue'));
Vue.component('StorageBrowserDialog', () => import('./components/settings/storageBrowserDialog.vue'));
Vue.component('StaticChartDataEditor', () => import('./components/propertyEditors/charts/staticChartDataEditor.vue'));
Vue.component('TableDataEditor', () => import('./components/propertyEditors/table/tableDataEditor.vue'));
Vue.component('DataBindingEditor', () => import('./components/propertyEditors/dataBinding/dataBindingEditor.vue'));
Vue.component('DataTextEditor', () => import('./components/propertyEditors/dataBinding/dataTextEditor.vue'));
Vue.component('DataSourceTableEditor', () => import('./components/dataSources/dataSourceTableEditor.vue'));
Vue.component('DataSourceFormFieldsEditor', () => import('./components/dataSources/dataSourceFormFieldsEditor.vue'));
Vue.component('DataSourceFileEditor', () => import('./components/dataSources/dataSourceFileEditor.vue'));
Vue.component('ScheduleDataEditor', () => import('./components/propertyEditors/schedule/scheduleDataEditor.vue'));
Vue.component('ScheduleNamesEditor', () => import('./components/propertyEditors/schedule/scheduleNamesEditor.vue'));
Vue.component('IconEditor', () => import('./components/propertyEditors/icons/iconEditor.vue'));
Vue.component('StringEditor', () => import('./components/propertyEditors/stringEditor.vue'));
Vue.component('ExtensionEditor', () => import('./components/propertyEditors/extensionEditor.vue'));
Vue.component('PasswordEditor', () => import('./components/propertyEditors/passwordEditor.vue'));
Vue.component('TextEditor', () => import('./components/propertyEditors/textEditor.vue'));
Vue.component('TopBottomLeftRightEditor', () => import('./components/propertyEditors/topBottomLeftRightEditor.vue'));
Vue.component('TransitionSelectionEditor', () => import('./components/propertyEditors/transitionSelectionEditor.vue'));
Vue.component('GoogleMapsEditor', () => import('./components/propertyEditors/googleMapsEditor.vue'));
Vue.component('TagEditor', () => import('./components/propertyEditors/tagEditor.vue'));
Vue.component('ProductSelectionEditor', () => import('./components/propertyEditors/products/productSelectionEditor.vue'));
Vue.component('MultiProductSelectionEditor', () => import('./components/propertyEditors/products/multiProductSelectionEditor.vue'));

Vue.component('AddEditScheduleDialog', () => import('./components/schedules/addEditScheduleDialog.vue'));
Vue.component('AddEditScheduledScreenDialog', () => import('./components/schedules/addEditScheduledScreenDialog.vue'));
Vue.component('ScheduleCalendar', () => import('./components/schedules/scheduleCalendar.vue'));
Vue.component('SchedulesCalendar', () => import('./components/schedules/schedulesCalendar.vue'));
Vue.component('ScheduleBlockDialog', () => import('./components/schedules/scheduleBlockDialog.vue'));
Vue.component('ScheduleSelector', () => import('./components/schedules/scheduleSelector.vue'));
Vue.component('Schedules', () => import('./components/schedules/schedules.vue'));
Vue.component('Triggers', () => import('./components/schedules/triggers.vue'));

Vue.component('AddScreenButton', () => import('./components/screens/addScreenButton.vue'));
Vue.component('TemplatePickerDialog', () => import('./components/screens/templatePickerDialog.vue'));
Vue.component('ScreenCreateForm', () => import('./components/screens/screenCreateForm.vue'));
Vue.component('AddWidgetDialog', () => import('./components/screens/addWidgetDialog.vue'));
Vue.component('BackgroundVideo', () => import('./components/screens/backgroundVideo.vue'));
Vue.component('EditScreenDialog', () => import('./components/screens/editScreenDialog.vue'));
Vue.component('ResolutionSelector', () => import('./components/screens/resolutionSelector.vue'));
Vue.component('Screen', () => import('./components/screens/screen.vue'));
Vue.component('ScreenPreviewFrame', () => import('./components/screens/screenPreviewFrame.vue'));
Vue.component('ScreenComponents', () => import('./components/screens/screenComponents.vue'));
Vue.component('ScreenPreviewer', () => import('./components/screens/screenPreviewer.vue'));
Vue.component('ScreenVersionsDialog', () => import('./components/screens/screenVersionsDialog.vue'));
Vue.component('Screens', () => import('./components/screens/screens.vue'));
Vue.component('ViewsDialog', () => import('./components/screens/viewsDialog.vue'));

Vue.component('Playlists', () => import('./components/playlists/playlists.vue'));
Vue.component('Playlist', () => import('./components/playlists/playlist.vue'));
Vue.component('AddPlaylistButton', () => import('./components/playlists/addPlaylistButton.vue'));
Vue.component('PlaylistTimeline', () => import('./components/playlists/playlistTimeline.vue'));
Vue.component('PlaylistItemEditor', () => import('./components/playlists/playlistItemEditor.vue'));
Vue.component('PlaylistScreenPreview', () => import('./components/playlists/playlistScreenPreview.vue'));
Vue.component('PlaylistPreviewFrame', () => import('./components/playlists/playlistPreviewFrame.vue'));
Vue.component('PlaylistTransitionDialog', () => import('./components/playlists/playlistTransitionDialog.vue'));

Vue.component('SettingsEditor', () => import('./components/settings/settingsEditor.vue'));

Vue.component('SigninDialog', () => import('./components/signin/signinDialog.vue'));
Vue.component('ForgottenPasswordDialog', () => import('./components/signin/forgottenPasswordDialog.vue'));
Vue.component('ResetPasswordDialog', () => import('./components/signin/resetPasswordDialog.vue'));
Vue.component('EmailVerificationDialog', () => import('./components/signin/emailVerificationDialog.vue'));

Vue.component('AcceptInvitationDialog', () => import('./components/signup/acceptInvitationDialog.vue'));
Vue.component('QuickEditApp', () => import('./components/quickEdit/quickEditApp.vue'));
Vue.component('SignupDialog', () => import('./components/signup/signupDialog.vue'));

Vue.component('EditPermissionsDialog', () => import('./components/team/editPermissionsDialog.vue'));
Vue.component('InviteTeamMemberDialog', () => import('./components/team/inviteTeamMemberDialog.vue'));

Vue.component('AddThemeButton', () => import('./components/themes/addThemeButton.vue'));
Vue.component('ThemeEditor', () => import('./components/themes/themeEditor.vue'));
Vue.component('ThemeSelector', () => import('./components/themes/themeSelector.vue'));
Vue.component('Themes', () => import('./components/themes/themes.vue'));

Vue.component('BrandKits', () => import('./components/brandKits/brandKits.vue'));
Vue.component('BrandKitEditor', () => import('./components/brandKits/brandKitEditor.vue'));
Vue.component('BrandKitCreateDialog', () => import('./components/brandKits/brandKitCreateDialog.vue'));
Vue.component('BrandKitSelector', () => import('./components/brandKits/brandKitSelector.vue'));

Vue.component('TransitionContainer', () => import('./components/transitions/transitionContainer.vue'));

Vue.component('AddEditTriggerDialog', () => import('./components/triggers/addEditTriggerDialog.vue'));
Vue.component('AddEditTriggeredScreenDialog', () => import('./components/triggers/addEditTriggeredScreenDialog.vue'));
Vue.component('TriggerHits', () => import('./components/triggers/triggerHits.vue'));
Vue.component('Triggers', () => import('./components/triggers/triggers.vue'));

Vue.component('AccountsView', () => import('./components/views/accountsView.vue'));
Vue.component('AuditLogView', () => import('./components/views/auditLogView.vue'));
Vue.component('ContentView', () => import('./components/views/contentView.vue'));
Vue.component('BrandKitsView', () => import('./components/views/brandKitsView.vue'));
Vue.component('DashboardView', () => import('./components/views/dashboardView.vue'));
Vue.component('PlayersView', () => import('./components/views/playersView.vue'));
Vue.component('ErrorLogView', () => import('./components/views/errorLogView.vue'));
Vue.component('ServerErrorLogView', () => import('./components/views/serverErrorLogView.vue'));
Vue.component('ErrorLogsView', () => import('./components/views/errorLogsView.vue'));
Vue.component('VideoToolsView', () => import('./components/views/videoToolsView.vue'));
Vue.component('ProfileView', () => import('./components/views/profileView.vue'));
Vue.component('S3ConfigurationsView', () => import('./components/views/s3ConfigurationsView.vue'));
Vue.component('SubscriptionsView', () => import('./components/views/subscriptionsView.vue'));
Vue.component('SchedulesView', () => import('./components/views/schedulesView.vue'));
Vue.component('ScreenView', () => import('./components/views/screenView.vue'));
Vue.component('SettingsView', () => import('./components/views/settingsView.vue'));
Vue.component('McpApiKeys', () => import('./components/settings/mcpApiKeys.vue'));
Vue.component('ChatDrawer', () => import('./components/chat/chatDrawer.vue'));
Vue.component('TeamsView', () => import('./components/views/teamsView.vue'));
Vue.component('ThemeView', () => import('./components/views/themeView.vue'));
Vue.component('ThemesView', () => import('./components/views/themesView.vue'));
Vue.component('TriggersView', () => import('./components/views/triggersView.vue'));
Vue.component('UsersView', () => import('./components/views/usersView.vue'));
Vue.component('ProductsView', () => import('./components/views/productsView.vue'));

Vue.component('Products', () => import('./components/products/products.vue'));
Vue.component('AddEditProductDialog', () => import('./components/products/addEditProductDialog.vue'));
Vue.component('ProductSourcesDialog', () => import('./components/products/productSourcesDialog.vue'));
Vue.component('AddProductSourceDialog', () => import('./components/products/addProductSourceDialog.vue'));
Vue.component('EditProductSourceDialog', () => import('./components/products/editProductSourceDialog.vue'));

Vue.component('DoodleWidget', () => import('./components/widgets/doodleWidget.vue'));
Vue.component('IframeWidget', () => import('./components/widgets/iframeWidget.vue'));
Vue.component('ImageWidget', () => import('./components/widgets/imageWidget.vue'));
Vue.component('Panel', () => import('./components/widgets/panel.vue'));
Vue.component('WidgetGroup', () => import('./components/widgets/widgetGroup.vue'));
Vue.component('CarouselWidget', () => import('./components/widgets/carouselWidget.vue'));
Vue.component('CarouselSlide', () => import('./components/widgets/carouselSlide.vue'));
Vue.component('TextWidget', () => import('./components/widgets/textWidget.vue'));
Vue.component('VideoWidget', () => import('./components/widgets/videoWidget.vue'));
Vue.component('StaticVideoWidget', () => import('./components/widgets/staticVideoWidget.vue'));
Vue.component('YoutubeVideo', () => import('./components/widgets/youtubeVideo.vue'));
Vue.component('QrCodeWidget', () => import('./components/widgets/qrCodeWidget.vue'));
Vue.component('SingleProduct', () => import('./components/widgets/products/singleProduct.vue'));
Vue.component('ProductGrid', () => import('./components/widgets/products/productGrid.vue'));
Vue.component('ClockWidget', () => import('./components/widgets/clockWidget.vue'));
Vue.component('CountdownWidget', () => import('./components/widgets/countdownWidget.vue'));
Vue.component('ShapeWidget', () => import('./components/widgets/shapeWidget.vue'));
Vue.component('MapWidget', () => import('./components/widgets/mapWidget.vue'));
Vue.component('SlideshowWidget', () => import('./components/widgets/slideshowWidget.vue'));
Vue.component('RssWidget', () => import('./components/widgets/rssWidget.vue'));
Vue.component('WeatherWidget', () => import('./components/widgets/weatherWidget.vue'));
Vue.component('ChartWidget', () => import('./components/widgets/charts/chartWidget.vue'));
Vue.component('TableWidget', () => import('./components/widgets/tableWidget.vue'));
Vue.component('DataValueWidget', () => import('./components/widgets/dataValueWidget.vue'));
Vue.component('DataListWidget', () => import('./components/widgets/dataListWidget.vue'));
Vue.component('ScheduleWidget', () => import('./components/widgets/scheduleWidget.vue'));
Vue.component('IconWidget', () => import('./components/widgets/iconWidget.vue'));
Vue.component('BannerWidget', () => import('./components/widgets/bannerWidget.vue'));

Vue.component('MblTicker', () => import('./components/widgets/extensions/mbl-ticker/mblTicker.vue'));

Vue.component('Product', () => import('./components/widgets/extensions/ls-retail/product.vue'));
Vue.component('ProductPanel', () => import('./components/widgets/extensions/ls-retail/productPanel.vue'));
Vue.component('MultipleSkuEditor', () => import('./components/propertyEditors/extensions/ls-retail/multipleSkuEditor.vue'));
Vue.component('ProductTagsEditor', () => import('./components/propertyEditors/extensions/ls-retail/productTagsEditor.vue'));
Vue.component('SkuEditor', () => import('./components/propertyEditors/extensions/ls-retail/skuEditor.vue'));

Vue.component('BaseLayout', () => import('./components/baseLayout.vue'));

Vue.component('marquee-text', MarqueeText)

// Expose the CodeMirror loader from the main bundle so lazy components (e.g. themeEditor) can
// fetch CodeMirror on demand without triggering the lazy-chunk import hang. See codeMirrorLoader.js.
Vue.prototype.$loadCodeMirror = loadCodeMirror;

// Builds /api/assets/data URLs, tagging them with the current playback context (device/player +
// screen/playlist) for bandwidth attribution. Usable in templates ($assetUrl) and methods.
Vue.prototype.$assetUrl = assetUrl;

// A component's role in the carousel family, or null for anything else.
//
// This is NOT a container test: `IsContainer` on the widget registration answers that, and the
// editor reads it through isContainerComponent(). This map exists only because the carousel
// renders one child at a time, which the generic renderer cannot express — so the editor needs
// slide-specific behaviour (which level to enter, what a slide's bounds are, what may be pasted
// where) in a handful of places. Every caller of this helper is carousel-only by definition; if
// that set ever needs to grow, container-widgets-plan.md replaces it rather than extending it.
//
// Lives here, on the entry bundle's prototype, rather than in services/: assetEnumerator.js
// documents that a module shared between the dashboard and the lazily-loaded device chunk got
// split into a shared chunk whose load hung the SPA. webcy.js is always loaded.
const CAROUSEL_ROLES = {
	carouselWidget: 'carousel',
	carouselSlide: 'slide'
};

// Pass a component ({ vueComponent }) — returns 'carousel' | 'slide', or null.
Vue.prototype.$carouselRole = (component) =>
	(component && CAROUSEL_ROLES[component.vueComponent]) || null;

if (window.ACCOUNT_ID) {
	Vue.use(DeviceHubPlugin);
	Vue.use(ChatHubPlugin);
}

//Vue.config.devtools = true;

Vue.use(VueRouter);
Vue.use(MasonryWall);

Vue.component('draggable', VueDraggable);

Vue.component('v-style', {
	render: function (createElement) {
		return createElement('style', this.$slots.default)
	}
})

Vue.filter('formatDate', function (value) {
	if (value) {
		var datePart = value.split('T')[0];
		var timePart = value.split('T')[1];

		var dateParts = datePart.split('-')
		var timeParts = timePart.split(':')

		return dateParts[2] + '.' + dateParts[1] + '.' + dateParts[0] + ' ' + timeParts[0] + ':' + timeParts[1];
	}

	return '';
})

Vue.filter('timeOnly', function (value) {
	var timePart = value.split('T')[1];
	var timeParts = timePart.split(':')

	return timeParts[0] + ':' + timeParts[1];
})

Vue.filter('dateOnly', function (value) {
	var datePart = value.split('T')[0];
	var dateParts = datePart.split('-')
	return dateParts[2] + '.' + dateParts[1] + '.' + dateParts[0]
})

Vue.filter('dateWithMonthNames', function (value) {
	var datePart = value.split('T')[0];
	var dateParts = datePart.split('-')
	var monthNames = ['janúar', 'febrúar', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'september', 'október', 'nóvember', 'desember'];
	return dateParts[2] + '. ' + monthNames[parseInt(dateParts[1]) - 1] + ' ' + dateParts[0]
})

Vue.filter('localize', function (value) {
	if (window._localizer) {
		for (var i = 0; i < window._localizer.length; i++) {
			if (window._localizer[i][0] == value) return window._localizer[i][1];
		}
	}

	return value;
})

window.$vue = Vue;

const routes = [	
	{ path: '/themes', component: () => import('./components/views/themesView.vue')},
	{ path: '/brand-kits', component: () => import('./components/views/brandKitsView.vue')},	
	{ path: '/theme/:themeId', component: () => import('./components/views/themeView.vue') },
	{ path: '/schedules', component: () => import('./components/views/schedulesView.vue') },
	{ path: '/triggers', component: () => import('./components/views/triggersView.vue') },
	{ path: '/players', component: () => import('./components/views/playersView.vue')  },
	{ path: '/multi-players', component: () => import('./components/views/playersView.vue')  },
	{ path: '/content', component: () => import('./components/views/contentView.vue') },
	{ path: '/assets', redirect: { path: '/content', query: { tab: 'assets' } } },
	{ path: '/products', component: () => import('./components/views/productsView.vue') },
	{ path: '/data-sources', component: () => import('./components/views/dataSourcesView.vue') },
	{ path: '/data-sources/:dataSourceId', component: () => import('./components/views/dataSourceView.vue') },
	{ path: '/analytics', component: () => import('./components/views/analyticsView.vue') },
	{ path: '/administration', component: () => import('./components/views/administrationView.vue') },
	{ path: '/accounts', component: () => import('./components/views/accountsView.vue') },
	{ path: '/users', component: () => import('./components/views/usersView.vue')  },
	{ path: '/team', component: () => import('./components/views/teamsView.vue') },
	{ path: '/audit-log', component: () => import('./components/views/auditLogView.vue')  },
	{ path: '/error-log', component: () => import('./components/views/errorLogView.vue')  },
	{ path: '/data-transfer', component: () => import('./components/views/dataTransferView.vue')  },
	{ path: '/s3-configurations', component: () => import('./components/views/s3ConfigurationsView.vue') },
	{ path: '/subscriptions', component: () => import('./components/views/subscriptionsView.vue') },
	{ path: '/profile', component: () => import('./components/views/profileView.vue')  },
	{ path: '/settings', component: () => import('./components/views/settingsView.vue')  },
	{ path: '/billing', component: () => import('./components/views/billingView.vue')  },
	{ path: '/global-settings', component: () => import('./components/views/globalSettingsView.vue')  },
	{ path: '/recycle-bin', component: () => import('./components/views/recycleBinView.vue') },
	{ path: '/screens', redirect: { path: '/content', query: { tab: 'screens' } } },
	{ path: '/screen/:screenId', component: () => import('./components/views/screenView.vue')  },
	{ path: '/playlists', component: () => import('./components/views/playlistsView.vue') },
	{ path: '/playlist/:playlistId', component: () => import('./components/views/playlistView.vue') },
	{ path: '/', component: () => import('./components/views/dashboardView.vue') },
	{ path: '*', component: () => import('./components/views/dashboardView.vue') },
];


const router = new VueRouter({
	routes
})

// Feature-gated routes: entry requires the account's plan to include the feature. This covers both
// clicking the nav item AND typing the URL. Not entitled -> cancel navigation and show the shared
// upgrade dialog (baseLayout listens for the 'webcy-upgrade' event). Fails open (hasFeature returns
// true on error / no subscription), and the server still 403s the underlying APIs.
const routeFeature = {
	'/products': 'products',
	'/analytics': 'products',   // product analytics is part of the Product integrations feature
	'/brand-kits': 'brandKits',
	'/data-sources': 'dataSources'
};

router.beforeEach((to, from, next) => {
	// Exact paths, plus a data source's own page (/data-sources/:id), which has a variable path.
	const feature = routeFeature[to.path] || (to.path.indexOf('/data-sources/') === 0 ? 'dataSources' : null);
	if (!feature || !window.ACCOUNT_ID) return next();

	// Load the entitlements helper lazily (its own chunk). Importing it statically at the top of the
	// ENTRY bundle broke the entry's module init and blanked the app; keeping it out of the entry
	// avoids that.
	import('./entitlements').then(({ hasFeature, featureMessage }) => {
		return hasFeature(window.ACCOUNT_ID, feature).then((allowed) => {
			if (allowed) {
				next();
				return;
			}
			window.dispatchEvent(new CustomEvent('webcy-upgrade', { detail: { message: featureMessage(feature) } }));
			// Stay on the current page for a nav-click; on a cold direct load (no previous route)
			// send them to the dashboard so there's content behind the dialog, not a blank view.
			if (from && from.matched && from.matched.length) next(false);
			else next('/');
		});
	}).catch(() => next());   // fail open: never block navigation on an entitlements lookup error
});


new Vue({
	router,
	vuetify,
	i18n,
}).$mount('#app');
